// extracted by mini-css-extract-plugin
module.exports = {"generate-note-pdf":"FormPrintOrDownloadTrigger_generate-note-pdf__1iqX_"};